import React, { Component } from 'react'
import ScheduleComponent from "./ScheduleComponent"
import { connect } from "react-redux"

import { SchoolInformationActions } from "../../../../store"
import * as Constants from '../../../../constants';
import {removeDataInLS} from '../../../../utils/LocalStorageUtil'

class ScheduleContainer extends Component {
    componentWillMount() {
        removeDataInLS(Constants.STEPPER_STATE_KEY_LS);
    }
    render() {
        return <ScheduleComponent {...this.props} />

    }
}

const mapStateToProps = (state) => {
 
    return {
        user: state.cognito.user,

        userInformation: state.userProfile.userInformation,

        activeSchool: state.schoolInformation.activeSchool,
        updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress,
        i18n: state.i18nMessages.i18n
    }
}
const mapDispatchToProps = (dispatch) => ({
    // todo : edit school put call
    editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
    updateSchoolScheduleConstraints:(ownerId, schoolId, school, scheduleConstraintsIndex) => dispatch(SchoolInformationActions.updateSchoolScheduleConstraints(ownerId, schoolId, school, scheduleConstraintsIndex))
}
  )
  
export default connect(mapStateToProps, mapDispatchToProps)(ScheduleContainer);